import { render, staticRenderFns } from "./TokenList.vue?vue&type=template&id=1635e671&scoped=true&"
import script from "./TokenList.vue?vue&type=script&lang=js&"
export * from "./TokenList.vue?vue&type=script&lang=js&"
import style0 from "./TokenList.vue?vue&type=style&index=0&id=1635e671&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1635e671",
  null
  
)

export default component.exports